import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        faq: [],
        faq_active: 0,
        top: 34
    },
    getters: {
        faq(state){
            return state.faq;
        },
        faq_active(state){
            return state.faq_active;
        },
        top(state){
            return state.top;
        }
    },
    mutations: {
        setFaq(state, data){
            state.faq = data.faq.items;

            state.faq_active = 'faq_' + data.faq.items[0].id
        },
        scroll(state, data){
            let menu = document.getElementById('faqMenu');
            if(menu){
                let box = document.getElementsByClassName('js-box');
                let active = null;
                for(let i = 0; i < box.length; i++){
                    let top = getCoords(box[i]).top;

                    if(data + 250 > top)
                        active = box[i].dataset.id;
                }
                state.faq_active = active;

                let active_el = document.querySelector( 'a[data-id="'+ active +'"]' );
                if(active_el){
                    state.top = (getCoords(active_el).top - getCoords(menu).top) + active_el.clientHeight / 2;
                }
            }
        },
        scrollTo(state, data){
            let menu = document.getElementById('faqMenu');

            if(menu) {
                let elem = document.querySelector('div.js-box[data-id="' + data + '"]');
                scrollTo(elem);

                state.faq_active = data;

                let active_el = document.querySelector('a[data-id="' + data + '"]');
                state.top = (getCoords(active_el).top - getCoords(menu).top) + active_el.clientHeight / 2;
            }
        }
    },
    actions: {
        LoadFaq ({commit}, active) {
            if(!this.state.faq.faq.length) {
                return new Promise((resolve, reject) => {
                    Vue.http.get('faq.json')
                        .then(response => response.json())
                        .then(data => {
                            commit('setFaq', {faq: data, active: active});
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    resolve();
                })
            }
        },
        scroll(store, data){
            store.commit('scroll', data)
        },
        scrollTo(store, data){
            store.commit('scrollTo', data)
        }
    }
};

function getCoords(elem) {
    let box = elem.getBoundingClientRect();
    let body = document.body;
    let docEl = document.documentElement;

    let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    let clientTop = docEl.clientTop || body.clientTop || 0;
    let clientLeft = docEl.clientLeft || body.clientLeft || 0;

    let top = box.top + scrollTop - clientTop;
    let left = box.left + scrollLeft - clientLeft;

    return {
        top: top,
        left: left
    };
}

function scrollTo(elem) {
    if(elem){
        let elem_coord = getCoords(elem).top - 240;
        let  scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if(elem_coord > scrollTop){
            scrollTop + 30 > elem_coord ? scrollTop = elem_coord : scrollTop += 30;
            window.scrollTo(0, scrollTop);

            setTimeout(() => {
                let scrollHeight = Math.max(
                    document.body.scrollHeight, document.documentElement.scrollHeight,
                    document.body.offsetHeight, document.documentElement.offsetHeight,
                    document.body.clientHeight, document.documentElement.clientHeight
                );
                if(scrollTop < elem_coord && (scrollTop + window.innerHeight) < scrollHeight)
                    scrollTo(elem)
            }, 1)
        } else{
            if(elem_coord < 0)
                elem_coord = 0;

            scrollTop - 30 < elem_coord ? scrollTop = elem_coord : scrollTop -= 30;
            window.scrollTo(0, scrollTop);
            setTimeout(() => {
                if(scrollTop > elem_coord)
                    scrollTo(elem)
            }, 1)
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/faq.js